import React from "react";
import classNames from "classnames";
import Modal from "react-bootstrap/Modal";

import "./styles.scss";

const MyDpdModal = props => (
  <Modal
    centered
    // Prevents close on outside click
    {...props}
    onHide={() => null}
    onEscapeKeyDown={props.onHide}
    dialogClassName={classNames("mydpd-modal", props.dialogClassName)}
  >
    {props.children}
  </Modal>
);

MyDpdModal.propTypes = {
  ...Modal.propTypes,
};

MyDpdModal.Header = Modal.Header;
MyDpdModal.Body = Modal.Body;
MyDpdModal.Footer = Modal.Footer;
MyDpdModal.Title = Modal.Title;
MyDpdModal.propTypes = Modal.propTypes;

export default MyDpdModal;
